var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2344 10.5486L23.0312 8.20483L20.6875 0.00170898H4.28125C2.33961 0.00170898 0.765625 1.57569 0.765625 3.51733V36.4861C0.765625 38.4277 2.33961 40.0017 4.28125 40.0017H27.7188C29.6604 40.0017 31.2344 38.4277 31.2344 36.4861V10.5486Z",
    fill: "#4086F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2344 10.5486V36.4861C31.2344 38.4277 29.6604 40.0017 27.7188 40.0017H16V0.00170898H20.6875L23.0312 8.20483L31.2344 10.5486Z",
    fill: "#4175DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2344 10.5486H23.0312C21.7422 10.5486 20.6875 9.4939 20.6875 8.20483V0.00170898C20.9922 0.00170898 21.2969 0.118896 21.5077 0.35335L30.8827 9.72835C31.1172 9.93921 31.2344 10.2439 31.2344 10.5486Z",
    fill: "#80AEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 18.8298H8.96875C8.32102 18.8298 7.79688 18.3057 7.79688 17.658C7.79688 17.0102 8.32102 16.4861 8.96875 16.4861H23.0312C23.679 16.4861 24.2031 17.0102 24.2031 17.658C24.2031 18.3057 23.679 18.8298 23.0312 18.8298Z",
    fill: "#FFF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 23.5173H8.96875C8.32102 23.5173 7.79688 22.9932 7.79688 22.3455C7.79688 21.6977 8.32102 21.1736 8.96875 21.1736H23.0312C23.679 21.1736 24.2031 21.6977 24.2031 22.3455C24.2031 22.9932 23.679 23.5173 23.0312 23.5173Z",
    fill: "#FFF5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 28.2048H8.96875C8.32102 28.2048 7.79688 27.6807 7.79688 27.033C7.79688 26.3852 8.32102 25.8611 8.96875 25.8611H23.0312C23.679 25.8611 24.2031 26.3852 24.2031 27.033C24.2031 27.6807 23.679 28.2048 23.0312 28.2048Z",
    fill: "#FFF5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3438 32.8923H8.96875C8.32102 32.8923 7.79688 32.3682 7.79688 31.7205C7.79688 31.0727 8.32102 30.5486 8.96875 30.5486H18.3438C18.9915 30.5486 19.5156 31.0727 19.5156 31.7205C19.5156 32.3682 18.9915 32.8923 18.3438 32.8923Z",
    fill: "#FFF5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 32.8923H18.3359C18.9837 32.8923 19.5078 32.3682 19.5078 31.7205C19.5078 31.0727 18.9837 30.5486 18.3359 30.5486H15.9922V32.8923Z",
    fill: "#E3E7EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 28.2048H23.0234C23.6712 28.2048 24.1953 27.6807 24.1953 27.033C24.1953 26.3852 23.6712 25.8611 23.0234 25.8611H15.9922V28.2048Z",
    fill: "#E3E7EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 23.5173H23.0234C23.6712 23.5173 24.1953 22.9932 24.1953 22.3455C24.1953 21.6977 23.6712 21.1736 23.0234 21.1736H15.9922V23.5173Z",
    fill: "#E3E7EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 18.8298H23.0234C23.6712 18.8298 24.1953 18.3057 24.1953 17.658C24.1953 17.0102 23.6712 16.4861 23.0234 16.4861H15.9922V18.8298Z",
    fill: "#E3E7EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.0b5f794fb28e05a0598015b6c4bd0b2b.svg";
export { ForwardRef as ReactComponent };